import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

function getSocketsApiBase() {
    return `${API_BASE_ADMIN}/api/v1/sockets`;
}

export const fetchSockets = async () => {
    const response = await apiFetch(`${getSocketsApiBase()}/admin`);
    if (!response.ok) throw new Error("Не вдалося завантажити розетки");
    return response.json();
};

export const updateSocket = async (id, data) => {
    const response = await apiFetch(`${getSocketsApiBase()}/admin/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося оновити розетку");
    }
    return response.json();
};

export const addSocket = async (data) => {
    const response = await apiFetch(`${getSocketsApiBase()}/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося додати розетку");
    }
    return response.json();
};
